import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    public authService: AuthService,
    public router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const BatchNum = state.url.split('/');
    this.authService.Batchnum = BatchNum[BatchNum.length - 1];
    
    const urls = state.url.split(this.authService.moveonKey);
    if (urls.length == 2) {
      if (urls[1] == "guest") {
        this.authService.connectAPI("auth/signin", { username: "guest", password: "1234" }).subscribe((res) => {
          if (!res.isError) {
            this.authService.setToken(res.result.token);
            this.authService.setUser(res.result.user);
            this.router.navigate([urls[0]]);
          } else this.authService.signOut();
          return true;
        });
      } else {
        this.authService.setToken(urls[1]);
        this.authService.connectAPI("auth/signin_auto", {}).subscribe((res) => {
          if (!res.isError) {
            this.authService.setUser(res.result);
            this.router.navigate([urls[0]]);
          } else this.authService.signOut();
          return true;
        });
      }
    } else {
      const user = this.authService.getUser();
      if (this.authService.isLoggedIn !== true || user.ProjectName != "FATEK") this.authService.signOut();
      return true;
    }
  }

}